import React from "react"
import "./index.css"

const AddOrderButton = ({ children, ...props }) => (
  <button className={"add-order-button"} {...props}>
    <i className={"fas fa-fw fa-plus"} />
    <span>Order</span>
  </button>
)

export default AddOrderButton



// WEBPACK FOOTER //
// ./src/components/add-order-button/AddOrderButton.js